import { deleteIFIModule } from '../../config/apiSinToken'
/**
 * AUTHOR: wraudales@ngshn.com
 * DESCRIPTION: INSERT MIPYME BY IFI
 * FECHA: 10-8-2022
 */
export const deletePrelegibilidad = async (idForm) => {
  const data = await deleteIFIModule(
    `api/v1/FormPreElegibility/deleteFormPreElegibilityById/${idForm}`,
  )
  return data
}

/**
 * AUTHOR: wraudales@ngshn.com
 * DESCRIPTION: Delete notification
 * FECHA: 4-4-2024
 */
export const deleteNotification = async (idNotification) => {
  const data = await deleteIFIModule(
    `api/v1/Notifications/delete/${idNotification}`,
  )
  return data
}

/**
 * Author: wraudales@ngshn.com
 * Description: Elimimar bloqueo MIPYME
 * Fecha: 31-5-2024
 */
export const deleteBlockingMipyme = async ({
  IdMiPyme,
  IdUserB2C,
  Justification,
  LockType,
}) => {
  const data = await deleteIFIModule(
    `api/v1/MiPymes/MiPymes/Delete-Blocking?IdMiPyme=${IdMiPyme}&IdUserB2C=${IdUserB2C}&Justification=${Justification}&LockType=${LockType}`,
  )
  return data
}
